import { render, staticRenderFns } from "./DiscardChanges.vue?vue&type=template&id=e0011172&scoped=true&"
import script from "./DiscardChanges.vue?vue&type=script&lang=ts&"
export * from "./DiscardChanges.vue?vue&type=script&lang=ts&"
import style0 from "./DiscardChanges.vue?vue&type=style&index=0&id=e0011172&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0011172",
  null
  
)

export default component.exports